<nav>
  <div class="navbar-wrapper">
    <div class="m-header">
      <div class="auth-header">
        <a href="javascript:"><img src="assets/images/authentication/logo.png" alt="logo" class="img-fluid"/></a>
      </div>
    </div>
    <app-nav-content (NavCollapsedMob)="navCollapseMob()" class="scroll-div w-100 compact"></app-nav-content>
  </div>
</nav>
 